<template>
  <main class="home">
    <brands/>
    <locations/>
    <jobs/>
  </main>
</template>

<script>

  import brands from './HomeBrands.vue'
  import locations from './HomeLocations.vue'
  import jobs from './HomeJobs.vue'

  export default {
    name: 'Home',
    components:{
      brands,
      locations,
      jobs
    },
    data () {
      return {
        msg: 'Home'
      }
    },
    //If this component hasn't been rendered.
    beforeRouteEnter (to, from, next) {
      document.title = to.meta.title
      next();
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Home.vue